import React from 'react'
import * as styles from "./styles/toggleSwitch.module.css";

const ToggleSwitch = ({ label = "", labelPosition = "right", hidden = false, checked, disabled, onChange }) => {
    return <label className={`${styles.toggle} ${styles[`${labelPosition}Label`]}`}>
        {!hidden && <>
            <input type='checkbox' tabIndex={0} checked={checked} onChange={disabled ? null : onChange} disabled={disabled} />
            <div />
        </>}
        {label.length > 0 && <span className={styles.label}>{label}</span>}
    </label>
}

export default ToggleSwitch